'use client';

import { Phone, MapPin } from 'lucide-react';
import Image from 'next/image';

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "SMMM Serkan AYDOĞMUŞ",
    "alternateName": "Serkan AYDOĞMUŞ Mali Müşavirlik",
    "description": "Denizli Merkezefendi&apos;nde muhasebe, mali müşavirlik ve vergi danışmanlığı hizmetleri sunan profesyonel muhasebe bürosu",
    "url": "https://serkanaydogmus.com.tr",
    "telephone": "+905544712131",
    "email": "info@serkanaydogmus.com.tr",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Sırakapılar Mh. 1583 Sk. No:27 Yakup Ünel İş Merkezi",
      "addressLocality": "Merkezefendi",
      "addressRegion": "Denizli",
      "postalCode": "20020",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 37.777364,
      "longitude": 29.083583
    },
    "openingHours": [
      "Mo-Fr 09:00-18:00"
    ],
    "serviceType": [
      "Muhasebe Hizmetleri",
      "Mali Müşavirlik",
      "Vergi Danışmanlığı",
      "Bordro Hazırlama",
      "Beyanname Hazırlama"
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "City",
      "name": "Denizli"
    },
    "founder": {
      "@type": "Person",
      "name": "Serkan AYDOĞMUŞ",
      "jobTitle": "Serbest Muhasebeci Mali Müşavir"
    },
    "sameAs": [
      "https://www.linkedin.com/in/serkanaydogmus",
      "https://www.facebook.com/serkanaydogmus"
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    
          <main className="min-h-screen bg-white relative overflow-hidden safari-height">
        {/* Arka plan görsel efekti */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100">
          <div className="absolute inset-0 bg-white/20"></div>
        </div>
        
        {/* Ana içerik */}
        <div className="relative z-10 h-full flex flex-col">
          {/* Hero bölümü */}
          <header className="flex-1 flex justify-center items-center px-6">
            <div className="max-w-4xl w-full">
              {/* Ana başlık */}
              <div className="text-center mb-8">
                {/* Logo */}
                <div className="mb-6 flex justify-center">
                  <Image
                    src="/Mm_logo.jpg"
                    alt="SMMM Serkan AYDOĞMUŞ Logo"
                    width={120}
                    height={120}
                    className="rounded-lg shadow-xl border border-gray-200"
                    priority
                  />
                </div>
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-black mb-6 leading-tight">
                  <span className="block">SMMM</span>
                  <span className="block md:inline" itemProp="name">Serkan AYDOĞMUŞ</span>
                </h1>
                <p className="sr-only">Denizli Merkezefendi&apos;nde muhasebe ve mali müşavirlik hizmetleri</p>
              </div>

              {/* İletişim bilgileri */}
              <address className="flex flex-col md:flex-row justify-center gap-8 md:gap-16 not-italic">
                <div className="flex items-center space-x-4 text-black">
                  <div className="bg-gray-100 border border-gray-200 rounded-full p-3 shadow-md" aria-hidden="true">
                    <Phone className="h-6 w-6 text-gray-700" />
                  </div>
                  <div>
                    <span className="sr-only">Telefon:</span>
                    <a href="tel:+905544712131" className="text-xl font-bold hover:text-gray-600 transition-colors" 
                       itemProp="telephone">0554 471 21 31</a>
                  </div>
                </div>

                <div className="flex items-center space-x-4 text-black">
                  <div className="bg-gray-100 border border-gray-200 rounded-full p-3 shadow-md" aria-hidden="true">
                    <MapPin className="h-6 w-6 text-gray-700" />
                  </div>
                  <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                    <span className="sr-only">Adres:</span>
                    <div className="text-xl font-bold" itemProp="streetAddress">Sırakapılar Mh. 1583 Sk. No:27</div>
                    <div className="text-lg">Yakup Ünel İş Merkezi</div>
                    <div className="text-lg">
                      <span itemProp="addressLocality">Merkezefendi</span>/<span itemProp="addressRegion">Denizli</span>
                    </div>
                  </div>
                </div>
              </address>
            </div>
          </header>

          {/* Harita bölümü */}
          <section className="px-6 pb-6 flex-shrink-0" aria-label="Konum Haritası">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
                <div className="h-64 md:h-72 lg:h-80">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d788.3852021503566!2d29.083582569625804!3d37.777363898249064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDQ2JzM4LjUiTiAyOcKwMDUnMDMuMiJF!5e0!3m2!1sen!2str!4v1750586456668!5m2!1sen!2str"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="SMMM Serkan AYDOĞMUŞ Ofis Konumu - Sırakapılar Mahallesi, Merkezefendi, Denizli"
                    className="w-full h-full"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Dekoratif elementler */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-gray-100/50 rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-gray-100/50 rounded-full blur-xl"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-gray-200/30 rounded-full blur-lg"></div>
      </main>
    </>
  );
}